<div *ngIf="isBusy" class="overlay" id="overlay" >
    <div class="d-flex justify-content-center overlay-content">
      <p class="overlay-message">{{displayMessage}}</p>
      <div class="spinner-border" role="status" >
        <span class="sr-only">Loading...</span>
      </div>
    </div>
</div>